module.exports = __webpack_public_path__ + "static/media/studiofoto-citybike-matyo.fa7ba29c.jpg";